import React from "react";
import {
  Segment,
  Checkbox,
  Label,
  Grid,
  Header,
  Icon
} from "semantic-ui-react";
import FilterService from "./FilterService";
import FilterAssignee from "./FilterAssignee";

const Filters = props => {
  let expandedFilters = props.expandedFilters;

  console.log("fi;tler props",props)

  if (typeof expandedFilters === "undefined") {
    expandedFilters = false;
  }

  let mainHeading =
    typeof props.mainHeading !== "undefined"
      ? props.mainHeading
      : "Filter Data";

  const getDefaultLength = () => {
    let length = 0;
    if (props.active.hasOwnProperty("market")) {
      length += props.active.market.length;
    }
    if (props.active.hasOwnProperty("status")) {
      length += props.active.status.length;
    }
    return length;
  };

  return (
    <Segment.Group style={{ marginTop: "0" }}>
      {mainHeading !== false ? (
        <Segment className="filter-section-expanded">
          <Header>
            {mainHeading}
            <div className="float-right filter-meta">
              <small className="gray-text" onClick={() => props.onSelectNone()}>
                Clear All Filters
              </small>
            </div>
          </Header>
        </Segment>
      ) : null}
      {expandedFilters === false ? (
        <Segment className="filter-section-expanded">
          <Grid stackable columns={2}>
            {Object.keys(props.parameters).map((filterName, i) => {
              if (filterName === "service" || filterName === "assignee")
                return null;

              return (
                <Grid.Column className="filter-group" key={i}>
                  <Header as="h4" style={{ marginBottom: ".1em" }}>
                    {props.parameters[filterName]}
                  </Header>
                  <div className="filter-meta" style={{ marginBottom: ".5em" }}>
                    <small
                      className="gray-text"
                      onClick={() => props.onSelectAll(filterName)}
                    >
                      Select All
                    </small>
                    <span> | </span>
                    <small
                      className="gray-text"
                      onClick={() => props.onSelectNone(filterName)}
                    >
                      Select None
                    </small>
                  </div>

                  <div className="filter-controls">
                    {Array.isArray(props.possible[filterName])
                      ? props.possible[filterName].map((value, j) => {
                          return (
                            <div style={{ padding: ".1em 0" }} key={`${filterName} ${j}`}>
                              <Checkbox
                                checked={
                                  props.active[filterName] &&
                                  props.active[filterName].includes(value)
                                }
                                onChange={() => {
                                  props.onToggle(filterName, value);
                                }}
                                style={{
                                  marginBottom: "0",
                                  marginTop: ".75em",
                                  marginRight: ".25em",
                                  height: "30px",
                                  verticalAlign: "middle"
                                }}
                              />
                              <Label
                                onClick={() => {
                                  props.onToggle(filterName, value);
                                }}
                                style={{
                                  height: "30px",
                                  verticalAlign: "middle",
                                  cursor: "pointer"
                                }}
                              >
                                {value}
                              </Label>
                            </div>
                          );
                        })
                      : Object.keys(props.possible[filterName]).map(
                          (filterKey, j) => {
                            return (
                              <div style={{ padding: ".1em 0" }} key={`${filterName} ${j}`}>
                                <Checkbox
                                  checked={
                                    props.active[filterName] &&
                                    props.active[filterName].includes(filterKey)
                                  }
                                  onChange={() => {
                                    props.onToggle(filterName, filterKey);
                                  }}
                                  style={{
                                    marginBottom: "0",
                                    marginTop: ".75em",
                                    marginRight: ".25em",
                                    height: "30px",
                                    verticalAlign: "middle"
                                  }}
                                />
                                <Label
                                  onClick={() => {
                                    props.onToggle(filterName, filterKey);
                                  }}
                                  style={{
                                    height: "30px",
                                    verticalAlign: "middle",
                                    cursor: "pointer"
                                  }}
                                  color={
                                    props.possible[filterName][filterKey].color
                                  }
                                >
                                  {props.possible[filterName][filterKey].label}
                                </Label>
                              </div>
                            );
                          }
                        )}
                  </div>
                </Grid.Column>
              );
            })}
          </Grid>
        </Segment>
      ) : (
        <Segment
          className="filter-section-collapsed"
          onClick={() => props.setExpanded("default", true)}
        >
          <Icon
            name="angle double right"
            size="big"
            style={{ float: "right" }}
          />
          <Header as="h4" style={{ margin: ".1em 0" }}>
            Status & Market
          </Header>

          {(Object.keys(props.active).includes("status") &&
            props.active.status.length) ||
          (Object.keys(props.active).includes("market") &&
            props.active.market.length) ? (
            <Label color="pink">
              {getDefaultLength()} Active Filter
              {getDefaultLength() !== 1 ? "s" : null}
            </Label>
          ) : (
            <small>Click to filter...</small>
          )}
        </Segment>
      )}
      {Object.keys(props.parameters).map(filterName => {
        if (filterName === "service")
          return (
            <FilterService
              key={`filter-${filterName}`}
              expanded={expandedFilters === filterName}
              possible={props.possible.service}
              active={props.active.service}
              onToggle={(filterName, filterKey) => {
                props.onToggle(filterName, filterKey);
              }}
              onSelectMultiple={(filterName, selections) => {
                props.onSelectMultiple(filterName, selections);
              }}
              setExpanded={value => props.setExpanded(filterName, value)}
            />
          );
        if (filterName === "assignee")
          return (
            <FilterAssignee
              key={`filter-${filterName}`}
              expanded={expandedFilters === filterName}
              possible={props.possible.assignee}
              active={props.active.assignee}
              onToggle={(filterName, filterKey) => {
                props.onToggle(filterName, filterKey);
              }}
              onSelectMultiple={(filterName, selections) => {
                props.onSelectMultiple(filterName, selections);
              }}
              setExpanded={value => props.setExpanded(filterName, value)}
            />
          );
      })}
      <Segment>
        <div className="center-text" style={{ marginTop: "1em" }}>
          <small className="gray-text">{props.matches} matches</small>
        </div>
      </Segment>
    </Segment.Group>
  );
};

export default Filters;



// WEBPACK FOOTER //
// ./src/components/misc/Filters.js